const ConvertStringToJS = (str) => {
  var script = document.createElement("script");
  script.text = str;
  document.head.appendChild(script).parentNode.removeChild(script);
}

const ConvertStringToHTML = (str) => {
  return new DOMParser().parseFromString(str, 'text/html');
}

const UpdateImageSrc = ($img, img_url) => {
  if (!$img) return;

  $img.removeAttribute('data-src')
  $img.removeAttribute('data-srcset')
  $img.removeAttribute('srcset')
  $img.classList.remove('lazyloaded')
  $img.classList.add('lazyload')
  $img.src = img_url
}

const GetCartJS = async () => {
  return fetch('/cart.js').then(res => res.json())
}

const UpdateCartAttribute = async(obj) => {
  let data = { attributes: obj };

  return await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => res.json());
}

ObserveIntersection = (node, config, callback) => {
  if (!node) callback(null);
  let observer = new IntersectionObserver((entries) => {
    callback(entries);
  }, config);
  
  observer.observe(node, config);  
  return observer;
}

ObserveMutation = (node, config, callback) => {
  if (!node) callback(null);
  let observer = new MutationObserver((mutations) => {
    callback(mutations);
  });
  
  observer.observe(node, config);  
  return observer;
}

AddItemsToCart = async (items_to_add) => {
  // items_to_add = [{
  //   quantity: qty,
  //   id: variant_id,
  //   selling_plan: selling_plan_id,
  //   properties: {}
  // }]
  return await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items: items_to_add })
  })
}

const UpdateCartDiscountCode = async(code) => {
  let data = { discount: code };

  return await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).then(res => res.json());
}

const GetSizeFilterId = () => {
  let size_filter_id = 'pf_opt_gre';
  switch(Shopify.shop.replace('.myshopify.com', '')) {
    case 'teppana-nl':
      size_filter_id = 'pf_opt_maat';
      break;
    case 'teppana-fr':
      size_filter_id = 'pf_opt_taille';
      break;
    case 'teppana-ch':
      size_filter_id = 'pf_opt_grosse';
      break;
    case 'teppana-uk':
      size_filter_id = 'pf_opt_size';
      break;
  }
  return size_filter_id;
}